import * as React from "react";
import classnames from "classnames";
import * as moment from "moment";
import { EMDASH } from "@eave/shared/utils/general";

const styles = require("./styles.module.scss");

/* helpers */

const OriginalValue: React.SFC<any> = ({ val, editing, onDoubleClick }) => {
  const classes = classnames({
    [styles.editVal__original]: !editing,
  });

  return (
    <div onDoubleClick={onDoubleClick} className={classes}>
      {val === "" ? EMDASH : val}
    </div>
  );
};

/* main */

const FORMAT_UI = "MM/DD/YYYY";
const FORMAT_WS = "YYYY-MM-DD";

const wsDateToUi = wsDate => {
  if (wsDate === null) {
    return "";
  }
  return moment(wsDate, FORMAT_WS).format(FORMAT_UI);
};

const initProps = ({ value }) => ({
  editing: false,
  currentValue: value,
});

interface IProps {
  field: string;
  value: string;
  onUpdate: Function;
}

class EditableDateValue extends React.Component<IProps, any> {
  constructor(props) {
    super(props);
    this.state = initProps(props);

    this.stopEditingAndUpdate = this.stopEditingAndUpdate.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(initProps(nextProps));
  }

  toggleEditing(editing: boolean) {
    this.setState({
      ...this.state,
      editing,
    });
  }

  stopEditingAndRevert() {
    this.setState(initProps(this.props));
  }

  stopEditingAndUpdate() {
    const val = this.state.currentValue;

    // validate before pushing to backend
    if (val !== null && !/^\d{4}-\d{2}-\d{2}$/.test(val)) {
      this.stopEditingAndRevert();
      return;
    }

    this.toggleEditing(false);

    // only update if changed
    if (val !== this.props.value) {
      this.props.onUpdate(val);
    }
  }

  onKeyDown(e) {
    if (e.key === "Enter" || e.key === "Escape") {
      e.preventDefault();
      e.stopPropagation();

      if (e.key === "Enter") {
        this.stopEditingAndUpdate();
      } else {
        this.stopEditingAndRevert();
      }
    }
  }

  onChange(e) {
    const { value } = e.target;

    this.setState({
      ...this.state,
      currentValue: value,
    });
  }

  render() {
    const { editing, currentValue } = this.state;
    const { value } = this.props;

    return (
      <div className={styles.editVal__container}>
        {editing ? (
          <input
            type="date"
            autoFocus
            value={currentValue}
            onKeyDown={this.onKeyDown}
            onChange={this.onChange}
            onFocus={e => e.currentTarget.select()}
            onBlur={this.stopEditingAndUpdate}
          />
        ) : (
          <OriginalValue
            onDoubleClick={() => this.toggleEditing(true)}
            val={wsDateToUi(value)}
            editing={editing}
          />
        )}
      </div>
    );
  }
}

export default EditableDateValue;
